import React from "react";

const ColorModeContext = React.createContext({
    toggleColorMode: () => { },
    setColorMode: () => { }
});

export default ColorModeContext